import { createAction, createSlice } from '@reduxjs/toolkit';
import { Reducers } from '@sda/enums/store';
import { getDateTime } from '@sda/utils/date';
import { extractSharedActions } from '@sda/utils/store';
import { createEntityAdapter } from '@client/store/entity.adapter';
import type { Request } from '@sda/interfaces/request';
import type { FetchDataType } from '@sda/sdk/interfaces';

export const startAssignRequestSupport = createAction<{ requestId: string, userId: string }>(`${Reducers.REQUESTS}/startAssignRequestSupport`);
export const startToggleScheduledPreRecording = createAction<{
  requestId: string;
  hasScheduledPreRecording: boolean;
}>(`${Reducers.REQUESTS}/startToggleScheduledPreRecording`);

export const startFetchRequest = createAction<string>(`${Reducers.REQUESTS}/startFetchRequest`);
export const unsubscribeRequest = createAction<string>(`${Reducers.REQUESTS}/unsubscribeRequest`);

export const requestAdapter = createEntityAdapter<Request & FetchDataType>({
  sortComparer: (a, b) => getDateTime(a.startTime).toMillis() - getDateTime(b.startTime).toMillis(),
});

const requestsSlice = createSlice({
  initialState: requestAdapter.getInitialState(),
  name: Reducers.REQUESTS,
  reducers: {
    ...extractSharedActions(requestAdapter),
    setRequest: requestAdapter.setOne,
  },
});

export const {
  setRequest, updateOne: updateRequest,
} = requestsSlice.actions;

export default requestsSlice.reducer;
